<template>
    <div class="w100 bgGrey">
        <article class="wContent center infor-detail-box">
            <div class="mw-modular-box">
                <el-row :gutter="20">
                    <el-col :span="16">
                        <div class="grid-content bgWhite p20" style="min-height: 650px;"> <!--870px-->
                            <h1 style="word-break: break-all;">{{ videoDetail ? videoDetail['title'] : '' }}</h1>
                            <div class="content-box mw-modular-box">
                                <!-- <div class="content-left textCenter">
                                    <p class="fontLight font14">— 分享 —</p>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" style="padding-top: 15px;" @click="showDetailCode()">
                                        <use xlink:href="#icon-weixin" ></use>
                                        <use xlink:href="#icon-weixin-copy" class="use"></use>
                                    </svg><br>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" style="padding-top: 15px;" @click="shareToqq($event)">
                                        <use xlink:href="#icon-qq" ></use>
                                        <use xlink:href="#icon-qq-copy" class="use"></use>
                                    </svg><br>
                                    <p class="fontLight font14 mw-modular-box">— 收藏 —</p>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" @click="handleCollect()">
                                        <use xlink:href="#icon-shoucang" ></use>
                                        <use xlink:href="#icon-shoucang-copy" class="use" :class="{show: isCollect}"></use>
                                    </svg><br>
                                </div> -->

                                <!-- <el-dialog
                                title=""
                                :visible.sync="wxCodeDialog"
                                width="280px">
                                <div class="textCenter" style="margin-top: -40px;">
                                    <img :src="qrcode" alt="" style="width: 240px; height: 240px;">
                                    <p>打开微信，点击底部的发现</p>
                                    <p>使用'扫一扫'即可将网页分享到朋友圈</p>
                                </div>
                                </el-dialog> -->

                                <div class="content-right p20">
                                    <p class="fontLight">编辑：{{ videoDetail ? videoDetail.operatorName : '未知' }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日期：{{ (videoDetail && videoDetail.operateTime) ? videoDetail.operateTime.substr(0, 10) : '' }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浏览量：{{ videoDetail ? (Number(videoDetail['playNum']) + Number(videoDetail['initPlayNum'])) : '' }}</p>
                                    <p class="mw-modular-box font14 fontLight" v-if="videoDetail && videoDetail.videoLabel">文章标签<span class="tag pointer" v-for="(table, tableI) in videoDetail.videoLabel" :key="tableI" >{{ table }}</span></p><!--@click="goSearchPage(table)"-->
                                    <div style="background: #f1f1f1; padding: 5px 10px; margin-bottom: 20px; border-radius: 5px;" v-if="videoDetail && videoDetail.adstract">
                                        <h4 class="font16" style="line-height: 40px;">视频摘要</h4>
                                        <p class="font14" style="line-height: 20px;">“ {{ videoDetail ? videoDetail.adstract : '' }} ”</p>
                                    </div>
                                    <video-player class="video-player vjs-custom-skin" style="margin-bottom: 30px; margin-top: 20px;"
                                        ref="videoPlayer"
                                        :playsinline="true"
                                        :options="playerOptions">
                                    </video-player>
                                    <small class="fontLighter">查看更多，请关注 <a href="http://www.chinatsi.com/" class="font14" style="color: rgb(0, 0, 255)">http://www.chinatsi.com/</a></small>
                                    <small class="fontLighter block" style="margin-top: 15px;">本文信息仅供参考，未经许可，不可转载。</small>
                                    
                                    <!-- <div style="display: flex; margin-top: 30px;" class="mw-modular-box content-page">
                                        <div class="pointer" style="flex: 1" @click="goDetailPage(detail_page.next[0])">
                                            <h1>上一篇</h1>
                                            <p class="font14">{{ detail_page.next.length > 0 ? detail_page.next[0]['the_title'] : '无'}}</p>
                                        </div>
                                        <div class="textRight pointer" style="flex: 1" @click="goDetailPage(detail_page.last[0])">
                                            <h1>下一篇</h1>
                                            <p class="font14 textRight">{{ detail_page.last.length > 0 ? detail_page.last[0]['the_title'] : '无' }}</p>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content">

                            <div class="inlineBlock p15 bgWhite xgtj w100" style="height: 250px; box-sizing: border-box;">
                                <h3 style="margin-bottom: 10px;" class="font16">相关推荐</h3>
                                <div class="hot-list w100 fontLight" v-for="(item, index) in videoList" :key="index">
                                    <router-link :to="'/home/video?id=' + item.viId">【{{ item.typeName }}】 {{ item.title }}</router-link>
                                </div>
                            </div>

                            <div class="varieties-box bgWhite mw-modular-box" style="min-height: 130px;">
                                <h3 class="font16">热门标签</h3>
                                <div class="varieties-list">
                                    <!--  @click="goSearchPage(item.labelTxt)" -->
                                    <span v-for="(item, index) in labelList" :key="index"><a v-if="item" class="fontWhite">{{ item }}</a></span>
                                </div>
                            </div>

                            <!-- <div v-if="adIDsIndex[0] && adIDsIndex[0]['list']">
                                <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 20px;">
                                    <img :src="item.adPicturePath" alt="" class="w100">
                                </a>
                            </div> -->
                            <!-- <HotRecord style="margin-top: 20px;" :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></HotRecord> -->

                        </div>
                    </el-col>
                </el-row>
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import HotRecord from '../../templates/hotRecord'
import Vue from 'vue'
import $ from 'jquery'
import QRCode from 'qrcode'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
export default {
    name: 'DetailVideo',
    components: { HotRecord, ConcatsControl },
    data () {
        return {
            // qqPic: require('../../assets/images/logo.png'),
            // qrcode: '',
            // detail_page: {
                //     last: {},
            //     next: {}
            // },
            // detail_info: {},
            // share_info: {},
            // isCollect: false,
            // wxCodeDialog: false,
            // isBefore: true
            id: '',
            labelList: [],
            adIDsIndex: [],
            adList: [],
            videoList: [],
            videoDetail: {},
            playerOptions: {
                
            }
        }
    },
    mounted () {
        // 初始化内容
        this.id = getQueryString('id');
        if (this.id) {
            this.getVideoDetail();
        } else {
            this.findAllVideoType();
        }
        this.getAdByAdp();
        this.tVideoList();
        this.gethotTab();
    },
    watch: {
    　　'$route': function (to, from) {
            this.$router.go(0);
    　　}
    },
    methods: {

        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'index38',
                id: adIDs['index38'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        // 相关推荐
        tVideoList () {
            const self = this;
            self.$post(`${baseUrl.online}/videoInfor/frontVideoList/1/6`, {videoTypeStatus: "Y"}).then(res => {
                if (res.code == 0) {
                    self.videoList = res.data ? res.data : [];
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到快讯信息');
            })
        },

        // 获取关键词信息
        gethotTab () {
            const self = this;
            self.$get(`${baseUrl.online}/videoInfor/hotTab`, {}).then(res => {
                if (res.code == 0) {
                    if (typeof(res.data) == 'string') {
                        self.labelList = res.data.split(',');
                    } else {
                        self.labelList = res.data;
                    }
                } else {
                    self.$message.error(res.message)
                }
            }).catch(err => {
                // self.$message.error('未获取到关键词信息')
            })
        },

        findAllVideoType () {
            const self = this;
            self.$get(`${baseUrl.online}/videoType/findAllType?status=Y`, {}).then(res => {
                if (res.code == 0) {
                    if (res.data.length > 0) {
                        self.getVideoListById(res.data[0]['typeId']);
                    }
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到分类信息')
            })
        },
        getVideoListById (typeId) {
            const self = this;
            self.$post(`${baseUrl.online}/videoInfor/frontVideoList/1/1`, {typeId: typeId}).then(res => {
                if (res.code == 0) {
                    if (res.data.length > 0) {
                        self.id = res.data[0]['viId'];
                        self.getVideoDetail();
                    } 
                    
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到快讯信息');
            })
        },
        // 记录点击量
        consultFollow () {
            const self = this;
            self.$get(`${baseUrl.online}/videoInfor/incr/${self.id}`, {}).then(res_1 => {
                if (res_1.code == 0) {
                    
                } else {
                    // self.$message.error(res_1.msg);
                }
            })
        },
         //根据id 获取页面详情
        getVideoDetail () {
             const self = this;
             self.$get(`${baseUrl.online}/videoInfor/findById/${self.id}`, {}).then(res => {
                if (res.code == 0) {
                    self.videoDetail = res.data;
                    if (self.videoDetail.videoLabel) {
                        if (typeof(self.videoDetail.videoLabel) == 'string') {
                            self.videoDetail.videoLabel = self.videoDetail.videoLabel.split(',');
                        }
                    }
                    self.playerOptions = {
                        //播放速度
                        playbackRates: [0.5, 1.0, 1.5, 2.0],
                        //如果true,浏览器准备好时开始回放。
                        autoplay:true,
                        // 默认情况下将会消除任何音频。
                        muted:false,
                        // 导致视频一结束就重新开始。
                        loop:false,
                        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                        preload:'auto',
                        language:'zh-CN',
                        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                        aspectRatio:'16:9',
                        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                        fluid:true,
                        //  sources: [{
                        //      //类型
                        //      type:"video/mp4",
                        //      //url地址
                        //      src:''
                        //  }],
                        //你的封面地址
                        //  poster:'',
                        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                        notSupportedMessage:'此视频暂无法播放，请稍后再试',
                        controlBar: {
                            timeDivider:true,
                            durationDisplay:true,
                            remainingTimeDisplay:false,
                            //全屏按钮
                            fullscreenToggle:true 
                        }
                    }
                    self.playerOptions.sources =  [{
                        //类型
                        type:"video/mp4",
                        //url地址
                        src: self.videoDetail.videoUrl
                    }];
                    self.playerOptions.poster = self.videoDetail.videoPicUrl;
                    self.consultFollow();
                } else {
                    // self.$message.error(res_1.msg);
                }
            })
        },


        // goSearchPage (item) {
        //     const self = this;
        //     self.$get(`${baseUrl.cyw}/inforLabel/addClickNum/${item}`, {}).then(res => {
        //         if (res.code == 0) {
        //             self.$router.push(`/home/searchPage?key=${item}&type=1`)
        //         } else {
        //             self.$message.error('跳转失败，请重试！')
        //         }
        //     }).catch(err => {
        //         self.$message.error('跳转失败，请重试！')
        //     })
        // },

        // 查询用户是否收藏
        // checkSave () {
        //     const self = this;
        //     const token_cyw = self.$cookies.get('token_cyw');
        //     if (token_cyw) {
        //         self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
        //             if (res_1.status == 200) {
        //                 self.$get(`${baseUrl.cyw}/inforUser/checkSave?userId=${res_1.data.id}&inforId=${self.id}`, {}).then(res => {
        //                     if (res.data == 'Y') {
        //                         self.isCollect = true;
        //                     }
        //                 })
        //             } else {
        //                 self.$message.error(res_1.msg);
        //             }
        //         })
        //     }
        // },

        // 记录收藏量
        // consultFollowN () {
        //     const self = this;
        //     $.ajax({
        //         url: `${baseUrl.service}/api_v3/consult_follow`,
        //         data: JSON.stringify({
        //             "primary_id": this.id,
        //             "follow": "N",
        //             "rq": "2020-01-01"
        //         }),
        //         headers: {
        //             "content-type": "application/json"
        //         },
        //         type: 'post',
        //         dataType: 'json',
        //         success: (res) => {},
        //         error: () => {}
        //     })
        // },

       

        // 获取上一条
        // getTGraphicSelUpDown (type) {
        //     const self = this;
        //     const url = type == 1 ? `${baseUrl.service}/api_v3/t_graphic_sel_up/${self.id}` : `${baseUrl.service}/api_v3/t_graphic_sel_down/${self.id}`;
        //     $.ajax({
        //         url: url,
        //         data: {},
        //         type: 'get',
        //         dataType: 'json',
        //         success: (res) => {
        //             if (res.code == 'ok') {
        //                 self.getInfos(type, res.data.primary_id);
        //             } else {
        //                 // self.$message.error(res.message);
        //             }
        //         },
        //         error: () => {
        //             // self.$message.error('未获取到详情信息')
        //         }
        //     })
        // },
        // 获取信息
        // getInfos (type, id) {
        //     const self = this;
        //     $.ajax({
        //         url: `${baseUrl.service}/api_v3/t_news_consult_sel_primary?primary_id=${id}`,
        //         data: {},
        //         type: 'get',
        //         dataType: 'json',
        //         success: (res) => {
        //             if (res.code == 'ok') {
        //                 if (type == 1) {
        //                     self.detail_page.last = res.data;
        //                 } else if (type == 2) {
        //                     self.detail_page.next = res.data;
        //                 } else {
        //                     self.detail_info = res.data;
        //                     self.share_info['the_title'] = res.data[0]['the_title'];
        //                     self.share_info['overview'] = res.data[0]['overview'];
        //                     self.compareDate(res.data[0].create_date);
        //                     self.getTGraphicSel();
        //                 }
        //             } else {
        //                 self.$message.error(res.message);
        //             }
        //         },
        //         error: () => {
        //             // self.$message.error('未获取到详情信息')
        //         }
        //     })
        // },

        // 添加/取消收藏
        // handleCollect () {
        //     const self = this;
        //     const token_cyw = self.$cookies.get('token_cyw');
        //     if (token_cyw) {
                
        //         self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
        //             if (res_1.status == 200) {
        //                 if (!self.isCollect) {
        //                     const param = { crmUserId: res_1.data.id, inforId: self.id, inforTypeId: self.detail_info[0]['consult_id'] }
        //                     self.$post(`${baseUrl.cyw}/inforUser/save`, param).then(res => {
        //                         if (res.code == 0) {
        //                             self.consultFollowN();
        //                             self.$message('收藏成功');
        //                             self.isCollect = true;
        //                         } else {
        //                             self.$message.error(res.message)
        //                         }
        //                     })
        //                 } else { // 已经收藏过了
        //                     self.$get(`${baseUrl.cyw}/inforUser/del?userId=${res_1.data.id}&inforId=${self.id}`, {}).then(res => {
        //                         if (res.code == 0) {
        //                             self.$message('取消收藏成功');
        //                             self.isCollect = false;
        //                         } else {
        //                             self.$message.error(res.message)
        //                         }
        //                     })
        //                 }
        //             } else {
        //                 self.$confirm(res_1.msg, '提示', {
        //                     confirmButtonText: '确定',
        //                     showCancelButton: false,
        //                     type: 'error'
        //                 }).then(() => {
        //                     self.$router.go(0)
        //                 })
        //             }
        //         }).catch(err_1 => {
        //             self.$confirm('未获取到用户信息，请重新登录', '提示', {
        //                 confirmButtonText: '确定',
        //                 showCancelButton: false,
        //                 type: 'error'
        //             }).then(() => {
        //                 self.$router.go(0)
        //             })
        //         })
        //     } else {
        //         self.$message({
        //             message: '请登录后收藏',
        //             type: 'warning'
        //         })
        //     }
        // },

        // 标签链接到搜索结果页
        // goSearchPage (name) {
        //     this.$router.push(`/home/searchPage?key=${name}&type=1`);
        // },

        // 上一篇/下一篇
        // goDetailPage (item) {
        //     if (item) {
        //         this.$router.push(`/home/inforDetail/${item.primary_id}`);
        //     }
        // },

        // goInforDetailPage (param) { // 跳转到资讯详情页
        //     this.$router.push(`/home/inforDetail/${param.primary_id}`)
        // },

        // 分享到QQ
        // shareToqq (event) {
        //     const self = this;
        //     let url = window.location.href;
        //     // let index = url.indexOf('http://') ? 6 : (url.indexOf('https://') ? 7 : 0);
        //     // url = url.substr(index, url.length)
        //     let p = {
        //          url: url,
        //         //  showcount: '0',/*是否显示分享总数,显示：'1'，不显示：'0' */
        //          desc: '',/*默认分享理由(可选)  */
        //          summary: self.share_info['overview'],/*分享摘要(可选) */
        //          title: self.share_info['the_title'],/*分享标题(可选)*/
        //         //  site: '',/*分享来源 如：腾讯网(可选)*/
        //         //  pics: 'data:image/png;base64' + self.share_info['base_file'], /*分享图片的路径(可选)*/
        //         //  style: '101',
        //         //  width: 199,
        //         //  height: 30
        //     };
        //     window.open(`https://connect.qq.com/widget/shareqq/index.html?url=${p.url}?sharesource=qzone&title=${p.title}&pics=&summary=${p.summary}&desc=${p.desc}`);
        // },

        // // 分享到微信
        // showDetailCode () {
        //     const self = this;
        //     // const url = window.location.origin + window.location.pathname + '#/inforDetailP/' + self.id;
        //     self.$get(`${baseUrl.informationShare}/tenxSteel/v2/info/getAppId?infoId=${self.id}`, {}).then(res => {
        //         const url = window.location.origin + '/phone/index.html?id=' + self.id + '&appid=' + res.data;
        //         QRCode.toDataURL(url).then(imgData => {
        //             if(imgData) {
        //                 self.qrcode = imgData;
        //             }
        //         });
        //         self.wxCodeDialog = true;
        //     }).catch(err => {
        //         const url = window.location.origin + '/phone/index.html?id=' + self.id + '&appid=500';
        //         QRCode.toDataURL(url).then(imgData => {
        //             if(imgData) {
        //                 self.qrcode = imgData;
        //             }
        //         });
        //         self.wxCodeDialog = true;
        //     })
            
        // },

        // 对比日期，4月1日之前的用t_graphic_sel, 之后的用newsdata
        // compareDate (_date) {
        //     const times = new Date('2020-04-03').getTime();
        //     const dateTimes = new Date(_date).getTime();
        //     if (times >= dateTimes) {
        //         this.isBefore = true;
        //     } else {
        //         this.isBefore = false;
        //     }
        // }
        
    },
}
</script>

<style scoped>
    .content-box { display: flex; }
    .content-left { flex: 1; padding-top: 20px; }
    .content-right { flex: 8; }
    .infor-detail-box .tag { border: 1px solid #eee; border-radius: 15px; padding: 1px 10px; color: #a30000; display: inline-block; margin-left: 10px; }
    .content-page h1 { font-size: 22px; }
    .content-page p { 
        line-height: 24px; margin-top: 15px;
        text-overflow:ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 320px;
    }
    .use { display: none; }
    .make-icon:hover > .use { display: block; }
    .show { display: block !important; }
    .hot-list { 
        height: 35px;
        line-height: 35px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
    .varieties-box { padding: 10px; margin-bottom: 20px; }
    .varieties-box h4 { display: flex; }
    .varieties-box h4 span { flex: 1; }
    .varieties-box > .varieties-list { padding: 20px 0 0 0; }
    .varieties-box > .varieties-list a { display: inline-block; padding: 10px 18px; margin-right: 8px; margin-bottom: 20px; border-radius: 3px; background: #a30000; }
</style>